import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AvailableCompanies, AvailableCompaniesResponse } from '@models';
import { ToastService } from '@modules';
import { CompaniesService } from '../../companies/companies.service';
import { ModalCompaniesService } from '../../companies/modal-companies/modal-companies.service';
import { ProjectsService } from '../../projects.service';

@Component({
  selector: 'ggi-journey-assing-company',
  templateUrl: './assing-company.component.html',
  styleUrls: ['./assing-company.component.scss'],
})
export class AssingCompanyComponent implements OnInit {
  @Input() projectId: string;
  @Input() typeProjectId: string;

  public form: FormGroup;
  public companies: AvailableCompanies[];

  constructor(
    private readonly service: ProjectsService,
    private readonly modalCompaniesService: ModalCompaniesService,
    private readonly fb: FormBuilder,
    private readonly companyService: CompaniesService,
    private readonly toast: ToastService
  ) {}

  ngOnInit(): void {
    this.form = this.generateForm();
    this.getCompanies();
  }

  public getCompanies(): void {
    this.companyService
      .getAvailableCompanies(this.projectId, this.typeProjectId)
      .subscribe((res: AvailableCompaniesResponse) => {
        this.companies = res.response;
      });
  }

  private generateForm(): FormGroup {
    return this.fb.group({
      company: [null, Validators.required],
    });
  }

  public cancel(): void {
    this.service.close();
  }

  public openCompany(): void {
    this.cancel();
    this.modalCompaniesService.continue();
  }

  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.toast.error();
      return;
    }
    const { company } = this.form.value;
    const data = {
      company,
    };
    this.service.patchAddCompany(data).subscribe(() => {
      this.cancel();
    });
  }
}
